import { atom } from 'nanostores';
export const $watchedSecondsAtom = atom(0);
